import "./plan-info.scss"
import FontHeading4 from "../../../../components/fonts/font-heading4/font-heading4";
import {FONT_COLOR, FONT_VARIANT} from "../../../../components/fonts/font-props";
import FontBody1 from "../../../../components/fonts/font-body1/font-body1";
import FontBody2 from "../../../../components/fonts/font-body2/font-body2";
import SubscriptionPlansStore, {IPlanButton, PlanStore} from "../../stores/subscription-plans-store";
import PlanDescription from "./plan-info-description/plan-info-description";
import Divider from "./divider/divider";
import UpgradeButtonAddons from "../upgrade-button-addons/upgrade-button-addons";
import {observer} from "mobx-react-lite";
import DashedSpacer from "./dashed-spacer/dashed-spacer";
import FlexSpaceBetweenWrapper from "../flex-space-between-wrapper/flex-space-between-wrapper";
import FontBody3 from "../../../../components/fonts/font-body3/font-body3";
import PlanPricing from "./plan-pricing/plan-pricing";
import Hr from "../../../../components/hr/hr";

export interface IPlanInfo {
    plan: PlanStore;
    hideButton?: boolean;
    planButtonData?: IPlanButton;
    readMoreUrl?: React.ReactNode;
}

const PlanInfo: React.FC<IPlanInfo> = observer(({plan, hideButton = false, planButtonData, readMoreUrl}: IPlanInfo) => {

    if (!plan) {
        return null;
    }

    const onUpgradeButtonClick = () => {
        SubscriptionPlansStore.generateSystemPlan(plan);
    }

    return (
        <div className="plan-info-wrapper">
            <div className="plan-info-details">
            <div>
                <FontHeading4 color={FONT_COLOR.PRIMARY3} variant={FONT_VARIANT.BOLD}>
                    {plan.name}
                </FontHeading4>
            </div>
            {
                (SubscriptionPlansStore.userPlan?.id === plan.id && SubscriptionPlansStore.childStoresCount > 0) &&
                <div>
                    <FontBody3 color={FONT_COLOR.PRIMARY2} variant={FONT_VARIANT.BOLD}>
                        Connected Stores ({SubscriptionPlansStore.childStoresCount})
                    </FontBody3>
                </div>
            }
            <div>
                <FontBody1 color={FONT_COLOR.PRIMARY2} variant={FONT_VARIANT.BOLD}>
                    {plan.formattedRmaQuota} {'\u00A0'}
                </FontBody1>
                <FontBody1 color={FONT_COLOR.PRIMARY2}>
                    returns
                </FontBody1>
            </div>

            <PlanPricing plan={plan}/>

            <div>
                <FontBody2 color={FONT_COLOR.PRIMARY2} variant={FONT_VARIANT.BOLD}>
                    {plan.formattedPricePerExtraRma}{'\u00A0'}
                </FontBody2>
                <FontBody2 color={FONT_COLOR.PRIMARY2}>
                    per extra return
                </FontBody2>
            </div>
            { !!readMoreUrl && 
                <div className="read-more-url">
                    {readMoreUrl}
                </div> 
            }
            {
                !hideButton && planButtonData &&
                <UpgradeButtonAddons
                    disabled={planButtonData.isCurrent}
                    onClick={onUpgradeButtonClick}
                    buttonCaption={planButtonData.caption}
                />
            }
            {
                plan.plan_description &&
                planButtonData?.isCurrent &&
                hideButton &&
                <Divider marginBottom={'36px'} marginTop={'40px'}/>
            }
            {
                planButtonData && Object.keys(planButtonData).length === 0 &&
                <DashedSpacer
                    bottomMargin={'20px'}
                    topMargin={SubscriptionPlansStore.userPlan?.id === plan.id && plan.hasInstallments() ? '0px' : '20px'}
                />
            }
            {(SubscriptionPlansStore.userPlan?.userAddons && SubscriptionPlansStore.userPlan?.userAddons?.length !== 0) &&
                <FlexSpaceBetweenWrapper>
                    <FontBody2 variant={FONT_VARIANT.BOLD} color={FONT_COLOR.PRIMARY2}>
                        Plan price
                    </FontBody2>
                    {!plan.isAnnualPlan()
                        ? <div className="plan-info-price-wrapper">
                            <FontBody2 variant={FONT_VARIANT.BOLD} color={FONT_COLOR.PRIMARY2}>
                                {plan.formattedBasePrice}
                            </FontBody2>
                            <FontBody2 color={FONT_COLOR.NEUTRAL3}> / month</FontBody2>
                        </div>
                        : !plan.hasInstallments()
                            ? <div className="plan-info-price-wrapper">
                                <FontBody2 variant={FONT_VARIANT.BOLD}>
                                    {plan.formattedBasePrice}
                                </FontBody2>
                                <FontBody2 color={FONT_COLOR.NEUTRAL3}> / year</FontBody2>
                            </div>
                            : <div className="plan-info-price-wrapper">
                                <FontBody2 variant={FONT_VARIANT.BOLD}>
                                    {plan.formattedBasePrice}
                                </FontBody2>
                                <FontBody2 color={FONT_COLOR.NEUTRAL3}> / {plan.parentPlan?.period} months</FontBody2>
                            </div>
                    }
                </FlexSpaceBetweenWrapper>
            }
            </div>
            <Hr />
            <PlanDescription isContactUsSection={false}
                             planDescription={plan.plan_description ?? ''}
                             shortPlanDescription={plan.short_description ?? ''}
            />
        </div>
    )
});

export default PlanInfo;